import React from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import { CheckboxTable } from "../../view/CheckboxTable";
import DomainManagementTableRow from "./DomainManagementTableRow";

function DomainManagementTable({ domainResultsList }) {

    const headers = [
        { name: 'NAME', width: '50%' },
        { name: 'KDC', width: '50%' },
    ]

    return (
        <>
            <CheckboxTable headers={headers} elements={domainResultsList}>
                {domainResultsList.map((data, index) => <DomainManagementTableRow key={index} data={data} index={index} />)}
            </CheckboxTable>
        </>
    );
}

function mapStateToProps(state) {
    debug("DomainTable mapStateToProps", state);
    const systemSettingsPage = state.systemSettingsPage;
    return {
        domainResultsList: systemSettingsPage.domains || []
    };
}

export default connect(mapStateToProps)(DomainManagementTable);
